import PropTypes from 'prop-types';
import { createContext, useState, useEffect, useRef } from 'react';
import useAuth from 'hooks/useAuth';
import useInterval from 'hooks/useInterval';

const initialState = {
};

const WebSocketContext = createContext(initialState);

function WebSocketProvider({ children }) {
    //const [socket, setSocket] = useState(null);
    const socket = useRef(null);

    const { user } = useAuth();
    const socketListeners = useRef({});
    const initSocket = () => {
        let _socket = null;
        if (process.env.NODE_ENV == "development") {
            _socket = new WebSocket("ws://localhost:3001");
        }
        else {
            const protocol = window.location.href.startsWith("http://") ? "ws://" : "wss://";
            _socket = new WebSocket(`${protocol}${window.location.host}`);
        }

        // console.log("Socket", _socket);
        _socket.onopen = (event) => {
            console.log("ws open");
            if (user != null) _socket.send(JSON.stringify({ type: "setUser", data: { _id: user._id } }));
        };

        _socket.onerror = (event) => {
            console.warn("ws error", event);
        };

        _socket.onmessage = (event) => {
            // console.log("ws msg", event.data);
            onSocketMessage(event.data);
        };

        _socket.onclose = (event) => {
            console.warn("ws close", event, socket.current);
            socket.current = null;
            // 접속이 끊기면 1초후에 재연결한다.
            if (socket.current == null) setTimeout(() => initSocket(), 1000);
        };
        socket.current = _socket;
    };

    useEffect(() => {
        initSocket();
    }, []);

    useEffect(() => {
        if (user != null && socket.current != null) send("setUser", { _id: user._id });
        else if (user == null && socket.current != null) send("resetUser", null);
    }, [user]);

    useInterval(() => {
        if (socket.current != null && socket.current.readyState == 1) send("ping");
    }, 10000);

    // Websocket Listener
    const addSocketListener = (name, listener) => {
        // console.log("Add Listener", name, listener);
        socketListeners.current[name] = listener;
    };

    const removeSocketListener = (name) => {
        // console.log("Remove Listener", name);
        delete socketListeners.current[name];
    };

    const send = (type, data) => {
        if (socket.current != null && socket.current.readyState == 1) {
            const msg = JSON.stringify({ type, data });
            // console.log("ws send", msg);
            socket.current.send(msg);
        }
    }

    const onSocketMessage = (data) => {
        // console.log("ws msg", data, socketListeners.current);
        const msg = JSON.parse(data);
        // if(msg.type == "pong") console.log("ws recv:", msg);
        Object.values(socketListeners.current).forEach(v => {
            v(msg);
        });
    };

    return (
        <WebSocketContext.Provider
            value={{
                addSocketListener,
                removeSocketListener,
                send
            }}
        >
            {children}
        </WebSocketContext.Provider>
    );
}

WebSocketProvider.propTypes = {
    children: PropTypes.node
};

export { WebSocketProvider, WebSocketContext };